import { Grid } from '@material-ui/core'
import AppBar from '@material-ui/core/AppBar'
import styled, { css } from 'styled-components'
import { rem } from '../../utils'
import { StyledNavItem } from './NavItem'
import { StyledPanelWrapper } from '../NavigationDropdown/StyledPanelWrapper'
import Slide from "@material-ui/core/Slide";

export const StyledDropdownPanel = styled(Grid)`
  cursor: default;
  width: 100%;
  padding-top: ${props => props.theme.typography.pxToRem(0)};
  padding-bottom: ${props => props.theme.typography.pxToRem(0)};

  > .MuiGrid-item {
    padding: 0 !important;
    width: 100%;

    > .MuiGrid-align-items-xs-flex-start {
      gap: ${props => props.theme.typography.pxToRem(25)};
    }

    > .MuiGrid-container {
        > .MuiGrid-item {
          padding-top: ${props => props.theme.typography.pxToRem(50)};
          padding-bottom: ${props => props.theme.typography.pxToRem(50)};
        }
     }
  }

  > .MuiGrid-container {
    padding-top: ${props => props.theme.typography.pxToRem(48)};
  }
`

export const StyledLogoWrapper = styled.div<{ $containerWidth: number; $sticky: boolean }>`
  margin-top: ${props => props.$sticky ? props.theme.typography.pxToRem(7) : props.theme.typography.pxToRem(0)};
  margin-left: ${props => props.$sticky ? props.theme.typography.pxToRem(15) : props.theme.typography.pxToRem(0)};
    
  ${props => props.theme.breakpoints.up('md')} {
    margin-top: ${props => props.$sticky ? props.theme.typography.pxToRem(11) : props.theme.typography.pxToRem(0)};
    z-index: 9;
  }

  ${props => props.theme.breakpoints.up('lg')} {
    margin-top: 0;
    position: absolute;
    transition: top 0.2s ease-in-out;
    left: 0;
    width: ${props => props.$sticky ? props.theme.typography.pxToRem(105) : 'auto'};
  }

  ${props => props.theme.breakpoints.up('xl')} {
    left: 0;
    margin-top: 0;
  }

  & figure {
    margin-left: ${props => props.$sticky ? 'auto' : '0'};
  }
`

type NavProps = {
  $secondary?: boolean
  $sticky?: boolean
  $visibleHeader?: boolean
  $isOpen?: boolean
  $offset?: number | null
}

const headerHeight = css<NavProps>`
  height: ${props => props.theme.typography.pxToRem(56)};

  ${props => props.theme.breakpoints.up('md')} {
    height: ${props => props.theme.typography.pxToRem(props.$sticky ? 80 : 80)};
  }
`

export const StyledNavBuffer = styled.div<NavProps>`
  height: ${props => props.theme.typography.pxToRem(56)};

  ${props => props.theme.breakpoints.up('sm')} {
      height: 56px;
  }
  ${props => props.theme.breakpoints.up('md')} {
    height: ${props => props.theme.typography.pxToRem(80)};
  }
`

export const StyledNavigationContainer = styled(AppBar) <NavProps>`
  position: ${props => props.$sticky ? 'fixed' : 'absolute'};
  top: ${props => props.$sticky ? 0 : `${(props.$offset || 0)}px`};
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  color: ${props => props.theme.palette.primary.dark};
  box-shadow: none;
  background-color: white;
  width: 100%;
  padding: 0;
  border-bottom: ${props => props.$sticky ? props.theme.typography.pxToRem(1) : '1px'} solid #cbcbcb;
  transition-property: height, transform, background-color !important;
  transition-duration: 0.2s !important;
  transition-timing-function: ease-in-out !important;
  ${headerHeight}

  &:focus-within {
    backdrop-filter: blur(10px);
  }

  ${props => props.theme.breakpoints.up('sm')} {
    padding: 0;
  }

  ${props => props.theme.breakpoints.up('lg')} {
    align-items: center;
    padding: 0;

    ${StyledLogoWrapper} {
      top: ${props => props.$sticky ? '50%' : '0'};
      transform: translateY(${props => props.$sticky ? '-50%' : '0'})
    }
  }

  ${props => props.theme.breakpoints.up('xl')} {
    max-width: 100%;
    right: 0;
  }

  ${StyledNavItem} {
    &::after {
      transform: translateY(${props => props.theme.typography.pxToRem(19)});
    }

    padding-top: ${props => (props.$visibleHeader && (props.theme.typography.pxToRem(props.$sticky ? 10 : 16))) || (!props.$visibleHeader && props.theme.typography.pxToRem(props.$sticky ? 10 : 16))};
    padding-bottom: ${props => props.$visibleHeader && (props.$secondary ? props.theme.typography.pxToRem(32) : props.theme.typography.pxToRem(40))};

    ${props => props.theme.breakpoints.up('md')} {
        padding-top: ${props => props.$visibleHeader && props.theme.typography.pxToRem(22)};
        padding-top: ${props => props.$sticky && props.theme.typography.pxToRem(22)};
        padding-bottom: ${props => props.$visibleHeader && props.theme.typography.pxToRem(22)};  
    }  

    ${props => props.theme.breakpoints.up('lg')} {
      padding-top: ${props => props.$visibleHeader && props.theme.typography.pxToRem(26)};
      padding-top: ${props => props.$sticky && props.theme.typography.pxToRem(0)};
      padding-bottom: ${props => props.$visibleHeader && props.theme.typography.pxToRem(20)};
    }
  }

  ${StyledDropdownPanel} {
    top: ${props => props.theme.typography.pxToRem(56)};
  }
    
  ${StyledPanelWrapper} {
    top: ${props => props.theme.typography.pxToRem(props.$sticky ? 80 : 80)};
  }
`

export const StyledRightMenuContainer = styled.div<{ $containerWidth: number }>`
  display: flex;
  align-items: center;
  margin-left: auto;
  order: 2;
  flex: 0 0 auto;
  column-gap: ${props => rem(12, props.theme)};
  height: 100%;
  padding-right: ${props => props.theme.typography.pxToRem(14)};

  ${props => props.theme.breakpoints.up(360)} {
    column-gap: ${props => rem(14, props.theme)};
  }

  ${props => props.theme.breakpoints.up('md')} {
      right: 0;
      grid-gap: 0;
      padding-right: 0;    
  }

  ${props => props.theme.breakpoints.up('lg')} {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
`

export const StyledNavItemContainer = styled(Grid) <{ $sticky?: boolean }>`
  & > div > div > a {
    &:hover {
      color: ${props => props.$sticky ? props.theme.palette.primary.main : props.theme.palette.text.primary};
    }
  }
`

export const StyledSlideContainer = styled(Slide)`
    ${props => props.theme.breakpoints.down('sm')} {
        height: 56px;
    }
`
